import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import saveAs from 'file-saver';

function toBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const result = String(reader.result || '');
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.readAsDataURL(blob);
  });
}

export async function exportFile({ blob, fileName, mimeType }) {
  // Browser/PWA path.
  if (!Capacitor.isNativePlatform()) {
    saveAs(blob, fileName);
    return true;
  }

  // Native path: write to app Documents and open share sheet.
  const base64Data = await toBase64(blob);
  await Filesystem.writeFile({
    path: fileName,
    data: base64Data,
    directory: Directory.Documents,
    recursive: true,
  });

  const fileUri = await Filesystem.getUri({
    path: fileName,
    directory: Directory.Documents,
  });

  await Share.share({
    title: 'NMhelper export',
    text: fileName,
    url: fileUri.uri,
    dialogTitle: 'Export file',
  });

  return true;
}

export function getExportMime(fileType) {
  if (fileType === 'csv') return 'text/csv;charset=utf-8;';
  if (fileType === 'doc') return 'application/rtf';
  if (fileType === 'pdf') return 'application/pdf';
  return 'application/vnd.oasis.opendocument.spreadsheet';
}
